'use strict'

import React from 'react';
import TrainingConfiguration from '../training/TrainingConfiguration.jsx';

let request=require('superagent');

class JWTConfig extends React.Component {
  render() {
    return (
      <div>
        <div style={{paddingBottom: 10}}>
          <b>Login service</b><br/>
          <input size="120" name="login" placeholder="Login service (url)" defaultValue="https://mycompany.com/sso?redirect_uri=mycompany.progreto.com"/><br/>
          <i>Login service (url) is the address users in your organization use to
            log in.</i>
        </div>
        <div style={{paddingBottom: 10}}>
          <b>Secret or public key</b><br/>
          <textarea name="secret" cols="80" rows="10" placeholder="Secret or public key"></textarea>
        </div>
        <div style={{paddingBottom: 10}}>
          <b>Issuer</b><br/>
          <input size="50" name="issuer" placeholder="Issuer (url)" defaultValue="https://mycompany.com/"/><br/>
          <i>Issuer (url) is the address that is used to sign the token.</i>
        </div>
        <div style={{borderRadius: 5, backgroundColor:"#e9e7e6", border:"solid 1px grey", padding:10, maxWidth:1016}}>
          <p>
            The SSO functionality relies
            on <a href="https://jwt.io/">JWT (Json Web Tokens)</a>, which is
            like a ticket issued by your organisation to confirm your identify,
            signed with your organizations certificate and sent as a parameter
            together with the request.
          </p>
          <p>
            When SSO is enabled the login process follows this sequence:
          </p>
          <ol>
            <li>The user navigates to mycompany.progreto.com (&lt;mycompany&gt; is the domain name you have configured for your account)</li>
            <li>Progreto identifies that the user is not authenticated</li>
            <li>The user is redirected to your login service, eg. https://mycompany.com/sso.</li>
            <li>Your login service authenticates the user and genrate a JWT with information about the user</li>
            <li>The JWT is sent together with the request to mycompany.progreto.com</li>
            <li>Progreto verifies the signature of the JWT and that the issuer for the JWT matches the defined issuer for your account.</li>
            <li>The user is given access to your account at Progreto</li>
          </ol>
          <p>
            The JWT (ticket or token) needs to contain the following keys:
          </p>
          <ul>
            <li><b>id</b> - the internal <b>unique</b> identity of the logged in user (user_id might also be used)</li>
            <li><b>name</b> - the full name of the logged in user</li>
            <li><b>email</b> - the email of the logged in user</li>
          </ul>
        </div>
      </div>
    );
  }
}

class SAML2Config extends React.Component {
  constructor(props) {
    super(props);
    this.state={content:undefined};
  }

  parseConfig(event) {
    var address=event.target.value;
    var url=undefined;
    try {
      var url=new URL(address);
      console.log("Use address '"+address+" -> "+url);
      request
        .post("/saml2/verifyMetadata")
        .send({"url":address})
        .then(
          function(res) {
            console.log("Got: "+JSON.stringify(res));
            this.setState({content:(
              <div>
                <b>Certificate(s)</b>:
                <ul>
                  {res.body.certificates.map(certificate=>
                    <li key={certificate.certificate}>
                      {certificate.content.subject.commonName} valid from {new Date(certificate.content.notBefore).toISOString().slice(0,10)} to {new Date(certificate.content.notAfter).toISOString().slice(0,10)}                    </li>
                  )}
                </ul>
                <b>Login</b>: {res.body.login}<br/>
                <b>Logout</b>: {res.body.logout}
              </div>
            )});
          }.bind(this),
          function(err,res) {
            this.setState({content:<i>Invalid metadata address, please provide the address of the metadata xml-file.</i>});
          }.bind(this)
        );
    } catch (invalidUrl) {
    }
  }

  render() {
    return (
      <div>
        <div>
          <b>{this.props.title}Metadata (url)</b><br/>
          <input size="120" name="metadata" autoComplete="off" placeholder="Address of your SAML2 metadata file (url)" onChange={this.parseConfig.bind(this)}/>
        </div>
        <div style={{paddingTop:10}}>
          {this.state.content}
        </div>
        <div style={{borderRadius: 5, backgroundColor:"#e9e7e6", border:"solid 1px grey", padding:10, maxWidth:1016}}>
          SAML2 is configured with metadata files. Please provide the url to your organizations metadata xml file.
          <p>
            The SAML2 configuration should include following claims:
          </p>
          <ul>
            <li><b>E-Mail-Address</b> - the email of the logged in user</li>
            <li><b>Given Name</b> - the given name of the logged in user</li>
            <li><b>Surname</b> - the surname of the logged in user</li>
          </ul>
        </div>
      </div>
    );
  }
}

class ConfigureSSO extends React.Component {
  constructor(props) {
    super(props);
    this.state={details:false,ssoType:"jwt"};
  }

  toggle(event) {
    event.preventDefault();
    this.setState({details:!this.state.details});
  }

  selectJWT(event) {
    console.log("JWT");
    this.setState({ssoType:"jwt"});
  }

  selectSAML2(event) {
    console.log("SAML2");
    this.setState({ssoType:"saml2"});
  }

  render() {
    if (this.props.user!==undefined && this.props.tenant.owner.id===this.props.user.id) {
      return this.state.details ? (
        <div>
          <h3>Single Sign On (SSO)</h3>
          <p>
            With SSO enabled, all users in your company can access Progreto
            without additional configuration of their user accounts. SSO can be
            configured to use SAML2 or JWT. For both altenatives you specify a
            dedicated domain for your company.
          </p>
          <div>
            <form action="/configureSSO" method="POST">
              <input type="hidden" name="tenant" value={this.props.tenant.id}/>
              <div style={{paddingBottom: 10}}>
                <b>Domain</b><br/>
                <input size="30" name="domain" placeholder="yourdomain" autoComplete="off" style={{textAlign:"right"}}/>.progreto.com<br/>
                <i>Domain is the address users in your organization shall use
                  to access your account.</i>
              </div>
              <input type="radio" onChange={this.selectJWT.bind(this)} name="ssoType" value="jwt" id="jwt" checked={this.state.ssoType==="jwt"}/><label htmlFor="jwt">JWT</label>
              <input type="radio" onChange={this.selectSAML2.bind(this)} name="ssoType" value="saml2" id="saml2" checked={this.state.ssoType==="saml2"} style={{marginLeft:30}}/><label htmlFor="saml2">SAML2</label>
              <div style={{marginTop:10, marginBottom:20}}>
              {this.state.ssoType==="jwt" ? <JWTConfig/> : <SAML2Config/>}
              </div>
              <input type="button" onClick={this.toggle.bind(this)} value="Cancel"/> <input type="submit" value="Configure SSO"/>
            </form>
          </div>
        </div>
      ) : (
        <div style={{paddingTop:20}}>
          {this.props.tenant.sso!==undefined ? (
            <div>
              <div>
                <b>SSO is configured</b>
                {this.state.edit!==true ? (
                  <a href="#" style={{paddingLeft:10}} onClick={event=>{event.preventDefault();this.setState({edit:true})}}><img src="/icons/pen_grey_tran.png"/></a>
                ) : null}
              </div>
              <div style={{paddingLeft: 20}}>
                {this.props.tenant.sso.enabled ? "Enabled domain" : "Domain"} <i><a href={"https://"+this.props.tenant.sso.domain+"/"}>{this.props.tenant.sso.domain}</a></i> using {this.props.tenant.sso.type!==undefined ? this.props.tenant.sso.type.toUpperCase() : <i>undefined authentication</i>} with
                {this.props.tenant.sso.type==="jwt" || this.props.tenant.sso.type===undefined
                  ? <span> login service <i><a href={this.props.tenant.sso.login}>{this.props.tenant.sso.login}</a></i> and issuer <i>{this.props.tenant.sso.issuer}</i></span>
                  : <span> metadata <i><a href={this.props.tenant.sso.metadata}>{this.props.tenant.sso.metadata}</a></i></span>
                }
                {this.props.tenant.sso.approved ? (
                  <div style={{paddingTop: 10}}>
                    <i>All users authenticated with SSO is approved to get access to this account.</i>
                  </div>
                ) : this.props.tenant.sso.enabled && this.props.tenant.sso.verifiedBy!==undefined ? (
                  <div style={{paddingTop:10}}>
                    SSO login is verified by:
                    <ul>
                      {this.props.tenant.sso.verifiedBy.map(user=><li key={user.id}>{user.name} ({user.email})</li>)}
                    </ul>
                    <i>All users authenticated with SSO will get access to this account.</i>
                    <form  style={{display: "inline-block", paddingLeft: 10}} action="/approveSSO" method="POST">
                      <input type="hidden" name="tenant" value={this.props.tenant.id}/>
                      <input type="submit" value="Approve SSO access"/>
                    </form>
                  </div>
                ) : null}
                {this.state.edit ? (
                  <div style={{paddingTop:10}}>
                    {this.props.tenant.sso.alternativeMetadata!==undefined && this.props.tenant.sso.alternativeMetadata.length>0 ? (
                      <p>
                        Alternative metadata:
                        <ul>
                          {this.props.tenant.sso.alternativeMetadata.map(item=>(
                            <li>
                              {item}
                              <div style={{display:"inline-block", paddingLeft: 10}}>
                                <form method="POST" action="/activateSSOMetadata">
                                  <input type="hidden" name="tenant" value={this.props.tenant.id}/>
                                  <input type="hidden" name="url" value={item}/>
                                  <input type="submit" value="Set active"/>
                                </form>
                              </div>
                              <div style={{display:"inline-block", paddingLeft: 10}}>
                                <form method="POST" action="/removeSSOMetadata">
                                  <input type="hidden" name="tenant" value={this.props.tenant.id}/>
                                  <input type="hidden" name="url" value={item}/>
                                  <input type="image" style={{verticalAlign:'middle'}} src="/icons/delete_grey.png"/>
                                </form>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </p>
                    ) : null}
                    <form action="/addSSOMetadata" method="POST">
                      <input type="hidden" name="tenant" value={this.props.tenant.id}/>
                      <SAML2Config title="Additinal "/>
                      <div style={{paddingTop:10}}>
                        <button onClick={()=>this.setState({edit:false})}>Cancel</button>
                        <span> </span>
                        <input type="submit" value="Add additional metadata url"/>
                      </div>
                    </form>
                  </div>
                ) : (
                  <div style={{paddingTop: 10}}>
                    <form action="/disableSSO" method="POST">
                      <input type="hidden" name="tenant" value={this.props.tenant.id}/>
                      <input type="submit" value="Disable SSO"/>
                    </form>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <a href="#" onClick={this.toggle.bind(this)}>Configure SSO (Single Sign On)</a>
          )}
        </div>
      );
    } else {
      return null;
    }
  }
}

export default class SSOConfiguration extends React.Component {
  render() {
    return this.props.training!==true ? (
      <ConfigureSSO {...this.props}/>
    ) : (
      <TrainingConfiguration {...this.props}/>
    )
  }
}



// WEBPACK FOOTER //
// ./views/settings/SSOConfiguration.jsx